// @flow
import { push } from 'react-router-redux';
import { fetchMe } from './user.actions';

import { getGtmAccounts, getContainers } from './gtmapi.actions';
import { getSummary } from './project.actions';

const GET_PLANS = '/api/plans?coupon=:coupon';
const WIZARD_API = '/api/projects/:id/wizard';
const PASS_SELECT_PLAN_API = '/api/projects/:id/pass-select-plan';
const SET_ACCOUNT = '/api/projects/:id/select-account?tid=:tid&isWebProperty=:iswp';
const SAVE_PLAN = '/api/charge';

export const PLANS_UPDATED = 'plans/UPDATED';
export const PLANS_UPDATING = 'plans/UPDATING';
export const WIZARD_PASSED = 'wizard/PASSED';
export const WIZARD_SAVING = 'wizard/SAVING';
export const WIZARD_SAVED = 'wizard/SAVED';

export const WIZARD_START_SELECT_ACCOUNT = 'wizard/WIZARD_START_SELECT_ACCOUNT';
export const WIZARD_END_SELECT_ACCOUNT = 'wizard/WIZARD_END_SELECT_ACCOUNT';

const dataLayer = window.dataLayer;

export const getPlansByCoupon = ({ coupon }: { coupon: string }) => {
  return (dispatch: Function) => {
    dispatch({ type: PLANS_UPDATING });
    fetch(GET_PLANS.replace(':coupon', coupon), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch({ type: PLANS_UPDATED, data });
      });
  };
};

export const getPassedSteps = ({ steps }: { steps: Array<string> }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_PASSED, data: steps });
  };
};

export const selectAccount = ({
  tid,
  projectId,
  accountId,
  isWebProperty = false
}: {
  tid: string,
  projectId: string,
  accountId: string,
  isWebProperty: boolean
}) => (dispatch: Function) => {
  dispatch({ type: WIZARD_START_SELECT_ACCOUNT });

  fetch(
    SET_ACCOUNT.replace(':iswp', isWebProperty ? 'true' : 'false')
      .replace(':tid', tid)
      .replace(':id', projectId),
    {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    }
  ).then(() => {
    const cb = (data) => {
      if (data && data[0] && data[0].id && !accountId) {
        dispatch(getContainers({ id: projectId, accountId: data[0].id }));
      }
    };

    dispatch({ type: WIZARD_END_SELECT_ACCOUNT });

    if (isWebProperty) {
      dispatch(fetchMe(() => dispatch(getSummary({ id: projectId, cb }))));
    } else {
      dispatch(fetchMe(() => dispatch(getGtmAccounts({ id: projectId, cb }))));
    }
  });
};

export const wizardDone = ({ id = 0, cb }: { id: number, cb: Function }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });

    return fetch(WIZARD_API.replace(':id', `${id}`), {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(fetchMe());
          dataLayer.push({ event: 'setup_completed' });
          cb && cb.call(this, data);
        }
      });
  };
};
export const passSelectPlan = ({ id = 0, cb }: { id: number, cb: Function }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });

    return fetch(PASS_SELECT_PLAN_API.replace(':id', `${id}`), {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(fetchMe());
          dataLayer.push({ event: 'setup_completed' });
          cb && cb.call(this, data);
        }
      });
  };
};

export const selectPlan = ({
  token,
  user,
  id = 0,
  plan,
  coupon,
  currency,
  cb
}: {
  token: Object,
  user: Object,
  plan: Object,
  id: number,
  coupon: string,
  currency: string,
  cb: Function
}) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });
    let planPayload = {
      planId: plan.id,
      coupon,
      pid: id
    };

    if (!user.stripeCustomerId && token && token.id && plan.price) {
      planPayload = { ...planPayload, token: token.id };
    }

    return fetch(SAVE_PLAN, {
      method: 'PUT',
      body: JSON.stringify(planPayload),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: WIZARD_SAVED, action: { id } });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(
            fetchMe(() => {
              cb && cb.call(this, data);
            })
          );
        }
      });
  };
};

export const setDatapointsDone = ({ id, cb }: { id: string, cb: Function }) => {
  return (dispatch: Function) => {
    dispatch({ type: WIZARD_SAVING });

    return fetch(`${WIZARD_API.replace(':id', `${id}`)}/datapoints-done`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    }).then((response) => {
      return dispatch(
        fetchMe(() => {
          if (cb) cb.call(this);
        })
      );
    });
  };
};

export default {
  selectPlan,
  passSelectPlan,
  getPassedSteps,
  wizardDone,
  selectAccount,
  getPlansByCoupon,
  setDatapointsDone
};



// WEBPACK FOOTER //
// ./src/actions/wizard.actions.js